export default __webpack_public_path__ + "static/media/moonbeam.c0522d32.svg";